import React from 'react';
import { Box, Typography, ButtonBase } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import CommentIdWithTooltip from './CommentIdWithTooltip';

interface AlertEventHeaderProps {
    label: string;
    isExpanded: boolean;
    onToggle: () => void;
    commentId?: number;
}

const AlertEventHeader: React.FC<AlertEventHeaderProps> = ({ label, isExpanded, onToggle, commentId }) => (
    <ButtonBase
        onClick={onToggle}
        sx={{ width: '100%', textAlign: 'left', display: 'block', p: 0, borderRadius: 1 }}
        disableRipple
    >
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <Typography variant="subtitle2" fontWeight="bold" sx={{ display: 'inline', mr: 1 }}>
                {label}
            </Typography>
            {commentId && <CommentIdWithTooltip commentId={commentId} />}
            <Box sx={{ ml: 'auto' }}>{isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</Box>
        </Box>
    </ButtonBase>
);

export default AlertEventHeader;
